import { Alert, Button, Container, Row, Spinner, Table } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../stores/hooks";
import { MyProfileState } from "../MyProfileSlice";
import { Formik } from "formik";
import { MyProfileDetailInterface } from "../models/MyProfileDetailInterface";
import ModuleConfig from "../config/ModuleConfig";
import FormField from "../../common/FormField";
import { useEffect } from "react";
import { updateMyProfile } from "../MyProfileAPI";
import { appState, setProfile } from "../../../stores/appSlice";

/**
 * MyProfileing Favourites list page
 */
const MyProfileCreate = () => {
  const dispatch = useAppDispatch();
  const { status } = useAppSelector(MyProfileState);
  const { profile } = useAppSelector(appState);
  const params = useParams();
  const navigator = useNavigate();
  const dispatchApp = useAppDispatch();

  const handleSubmit = async (
    values: MyProfileDetailInterface,
    formMethod: any
  ) => {
    const res: any = await updateMyProfile(values);
    if (res?.data?.status == 200) {
      dispatchApp(setProfile(res?.data?.data));
      navigator("/");
    } else if (res.errors && res.message) {
      const errors: any = {};
      const errorKeys = Object.keys(res.errors);
      for (var i = 0; i < errorKeys.length; i++) {
        errors[errorKeys[i]] = res.errors[errorKeys[i]][0];
      }
      formMethod.setErrors(errors);
    } else {
      navigator("/");
    }
  };


  return (
    <>
      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-header">
              <h5>Edit Profile</h5>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <Formik
                    initialValues={
                      profile ? profile : ModuleConfig.formDefaultValue
                    }
                    validate={(values) => {
                      const errors: any = {};
                      const fields = Object.keys(ModuleConfig.formFields);
                      for (let index = 0; index < fields.length; index++) {
                        if (
                          !values[fields[index]] &&
                          ModuleConfig.formFields[fields[index]].isRequired
                        ) {
                          errors[fields[index]] = "Required";
                        }
                      }

                      return errors;
                    }}
                    enableReinitialize={true}
                    onSubmit={handleSubmit}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                      setFieldValue,
                    }) => (
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          {Object.keys(ModuleConfig.formFields).map(
                            (field: string, index: number) => {
                              const fieldDetails =
                                ModuleConfig.formFields[field];
                              return (fieldDetails.isAdd == false &&
                                params.id) ||
                                fieldDetails.isAdd == undefined ? (
                                <div
                                  key={`field_${index}`}
                                  className={fieldDetails.colWidth}
                                >
                                  <FormField
                                    name={field}
                                    fieldDetails={fieldDetails}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    setFieldValue={setFieldValue}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                  />
                                </div>
                              ) : null;
                            }
                          )}
                        </div>
                        <hr />
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={status === "loading"}
                        >
                          Submit
                        </button>
                      </form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default MyProfileCreate;
